import classes from "../visura-to-excel.module.scss";
import classNames from "classnames";
import { Status } from "../visura.slice";
import Spinner from "@/components-library/widgets/spinner/spinner";
function DragDropZoneRendering({
  onDrag,
  handleDrop,
  onChange,
  onButtonClick,
  dragActive,
  inputRef,
  status,
}) {
  if (status !== Status.IDLE && status !== Status.SUCCESS) {
    return <Spinner />;
  } else {
    return (
      <form
        className={classes.formFileUpload}
        onDragEnter={onDrag}
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          ref={inputRef}
          type="file"
          className={classes.inputFileUpload}
          multiple={true}
          onChange={onChange}
        />
        <label
          className={classNames(classes.labelFileUpload, {
            [classes.dragActive]: dragActive,
          })}
          htmlFor="input-file-upload"
        >
          <div>
            <button className={classes.uploadButton} onClick={onButtonClick}>
              Seleziona o trascina un file
            </button>
            <br></br>
          </div>
        </label>
        {dragActive && (
          <div
            className={classes.dragFileElement}
            onDragEnter={onDrag}
            onDragLeave={onDrag}
            onDragOver={onDrag}
            onDrop={handleDrop}
          ></div>
        )}
      </form>
    );
  }
}
export default DragDropZoneRendering;
